import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

export const externalRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const externalUrl = route.data['externalUrl'] as string;

  if (externalUrl) {
    window.location.href = externalUrl;

    return false;
  }

  return true;
};
